import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useEffect, useState } from 'react';
import { APOLLO_COMMERCE_CONTEXT } from '@chegg/commerce-utils';
import { GET_VENDOR_PLAN } from '../gql/queries';
import { initApolloClient } from '../apollo/client';
export var getVendorPlan = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(code) {
    var client,
      _yield$client$query,
      data,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          client = _args.length > 1 && _args[1] !== undefined ? _args[1] : initApolloClient();
          _context2.next = 3;
          return client.query({
            query: GET_VENDOR_PLAN,
            context: _defineProperty({}, APOLLO_COMMERCE_CONTEXT, true),
            variables: {
              code: code
            }
          });
        case 3:
          _yield$client$query = _context2.sent;
          data = _yield$client$query.data;
          return _context2.abrupt("return", data.vendorPlan ? data.vendorPlan : {});
        case 6:
        case "end":
          return _context2.stop();
      }
    }, _callee);
  }));
  return function getVendorPlan(_x) {
    return _ref.apply(this, arguments);
  };
}();
var useGetProductRecommendation = function useGetProductRecommendation(recurlyProductCode, currencyCode) {
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    recommendation = _useState2[0],
    setRecommendation = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    loading = _useState4[0],
    setLoading = _useState4[1]; // Track loading state
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    error = _useState6[0],
    setError = _useState6[1];
  useEffect(function () {
    var transformVendorPlanToProductRecommendation = function transformVendorPlanToProductRecommendation(vendorPlan) {
      var _vendorPlan$available, _vendorPlan$available2, _vendorPlan$available3, _matchedPrice$price, _matchedPrice$currenc, _vendorPlan$entitleme;
      var matchedPrice = (_vendorPlan$available = (_vendorPlan$available2 = vendorPlan.availablePrices) === null || _vendorPlan$available2 === void 0 ? void 0 : _vendorPlan$available2.find(function (price) {
        return price.currency === currencyCode;
      })) !== null && _vendorPlan$available !== void 0 ? _vendorPlan$available : (_vendorPlan$available3 = vendorPlan.availablePrices) === null || _vendorPlan$available3 === void 0 ? void 0 : _vendorPlan$available3.find(function (price) {
        return price.currency === 'USD';
      });
      return {
        productRecommendation: {
          offerings: [{
            plan: {
              code: vendorPlan.code || '',
              price: {
                price: (_matchedPrice$price = matchedPrice === null || matchedPrice === void 0 ? void 0 : matchedPrice.price) !== null && _matchedPrice$price !== void 0 ? _matchedPrice$price : 0,
                currency: (_matchedPrice$currenc = matchedPrice === null || matchedPrice === void 0 ? void 0 : matchedPrice.currency) !== null && _matchedPrice$currenc !== void 0 ? _matchedPrice$currenc : ''
              },
              billingType: vendorPlan.billingType,
              billingPeriod: vendorPlan.billingPeriod,
              description: vendorPlan.description,
              entitlements: (_vendorPlan$entitleme = vendorPlan.entitlements) !== null && _vendorPlan$entitleme !== void 0 ? _vendorPlan$entitleme : [],
              experiment: vendorPlan.experiment,
              id: vendorPlan.id || '',
              name: vendorPlan.name || '',
              family: vendorPlan.family,
              trialPeriod: vendorPlan.trialPeriod,
              state: vendorPlan.state
            },
            basePlan: null,
            savings: null,
            allowedActions: ['JOIN']
          }]
        }
      };
    };
    setLoading(true);
    getVendorPlan(recurlyProductCode).then(function (response) {
      var transformedResponse = transformVendorPlanToProductRecommendation(response);
      setRecommendation(transformedResponse);
      setLoading(false);
    })["catch"](function (reason) {
      setError(new Error('failed to fetch product recommendation with reason: ' + reason));
      setLoading(false);
    });
  }, []);
  return {
    data: recommendation,
    loading: loading,
    error: error
  };
};
export default useGetProductRecommendation;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/dist/esm/hooks/useGetProductRecommendation.js
// module id = 5223
// module chunks = 11